export default class Category {
	constructor(domElement, config) {
		try {
			this.element = domElement;
			this.groupIndex = config.groupIndex;
			this.uid = domElement.getAttribute('data-uid');

			this.config = {
				disabled: false,
				unavailable: false,
				active: false,

				disabledClass: 'disabled',
				unavailableClass: 'unavailable',
				activeClass: 'selected',

				...config
			};

			this.element.addEventListener('click', e => {
				if (this.config.disabled) {
					return;
				}

				this.setActive(!this.config.active);
				if (config.onClick) {
					config.onClick(this);
				}
			});

			if (this.config.unavailable) {
				this.setUnavailable(true);
			}
		} catch (e) {
			console.error(e);
		}
	}

	/**
	 * The DOM element of this category.
	 * 
	 * @returns {HTMLElement}
	 */
	getElement() {
		return this.element;
	}

	/**
	 * Returns the index of the group this category belongs to.
	 * 
	 * @returns {integer}
	 */
	getGroupIndex() {
		return this.groupIndex;
	}

	/**
	 * Gets the uid of this group, either the l10n_parent or the "real" uid.
	 * 
	 * @returns {integer}
	 */
	getUid() {
		return this.uid;
	}

	/**
	 * Disables the item. Removes active state if necessary.
	 * Makes this item unclickable and unusable.
	 */
	disable() {
		this.config.active = false;
		this.config.disabled = true;
		this.element.classList.remove(this.config.activeClass);
		this.element.classList.add(this.config.disabledClass);
	}

	/**
	 * Enable this item.
	 */
	enable() {
		if (this.config.unavailable) {
			return;
		}

		this.config.disabled = false;
		this.element.classList.remove(this.config.disabledClass);
	}

	/**
	 * Gets active state.
	 * 
	 * @returns {boolean}
	 */
	isActive() {
		return this.config.active;
	}

	/**
	 * Gets disabled state.
	 * If true, this item is not clickable or usable.
	 * 
	 * @returns {boolean}
	 */
	isDisabled() {
		return this.config.disabled;
	}

	/**
	 * Sets active state.
	 * 
	 * @param {boolean} bActive 	True or false.
	 */
	setActive(bActive) {
		if (this.config.disabled) {
			return;
		}

		this.config.active = bActive;
		if (bActive) {
			this.element.classList.add(this.config.activeClass);
		} else {
			this.element.classList.remove(this.config.activeClass);
		}
	}

	/** 
	 * Practically makes this category entirely unusable.
	 * Enabling is not available, it alwas is grayed out.
	 * 
	 * @param {boolean} bUnavailable 	True to make unavailable, false to enable again.
	 */
	setUnavailable(bUnavailable) {
		this.config.unavailable = bUnavailable;
		if (bUnavailable) {
			this.disable();
			this.element.classList.add(this.config.unavailableClass);
		} else {
			this.enable();
			this.element.classList.remove(this.config.unavailableClass);
		}
	}

	/**
	 * Returns unavailable status, if false, this category is not clickable or usable.
	 * 
	 * @returns {boolean}
	 */
	isAvailable() {
		return !this.config.unavailable;
	}
}
